/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>upgrade-feature.directive.ts</name>
///
/// <description>
///  
///  
///  
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>24 Jan 2018</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { Directive, ElementRef, Input, HostListener, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Params } from "@angular/router";
import { Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HydUser } from '../../models/user';  
import { PermissionsService } from './permissions.service';  
import {  Feature} from '../../services/Crestron.HydrogenAPI.AccountApi.service';

@Directive({ selector: '[upgrade]' })
export class UpgradeFeatureDirective implements OnInit {

    @Input() featureKey: string;  
   
    constructor(private el: ElementRef,  
                    private hydUser: HydUser, 
                    private route: ActivatedRoute, 
                    private permissionsService: PermissionsService) {   
                           
    } 
     //----------------------------------------------------------
    //ngOnInit
    //----------------------------------------------------------
    ngOnInit() {

        this.evaluateFeature();
           
    }

     //----------------------------------------------------------
    //onActivate
    //----------------------------------------------------------
    @HostListener('window:onactivate', ['$event'])
    private onActivate(event: Event) {
        this.evaluateFeature();
    }

    //----------------------------------------------------------
    //evaluateFeature
    //----------------------------------------------------------
    private evaluateFeature() {
        let tier: string = this.permissionsService.tier;
        this.featureKey = this.route.snapshot.data["feature"];
        let permission: any = (this.featureKey) ? this.permissionsService.getPermission(this.featureKey) : null;

        //Hide Upgrade Section 
        if (permission) {
            if (permission.Tiers && permission.Tiers[tier].IsEnable) {//Enable it 

                    this.el.nativeElement.style.display = "none";
                    try {
                        this.el.nativeElement.remove();
                    }
                    catch (ex) {
                    }
            }


        }
    }

   
     
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/authorization/permissions/upgrade-feature.directive.ts